import { runtimeConfig } from "@src/runtime-config";

/** The regions the app is running in. Either EU or US. */
export const serverRegion = runtimeConfig.appEnv.includes("eu") ? "eu" : "us";

/** Whether the app is running on production or not (staging or dev) */
export const isProductionEnvironment = runtimeConfig.environment === "production";

/** Whether the app is running on pre-production environments (staging or dev) or not */
export const isPreProductionEnvironment = runtimeConfig.environment === "dev" || runtimeConfig.environment === "staging";

/** Validate if is a number environment */
export function isNumberedDevEnvironment() {
  const domain = window.location.hostname;
  const isMatch = /^dev([1-9]|1[0-9]|20)\.sphere\.(staging|dev)\./.test(domain);
  return isMatch;
}